import { Box, Chip } from "@mui/material";
import { useAppSelector } from "../../../app/hooks";

interface Props {
  tags: string[];
}

const TalentTags = ({ tags }: Props) => {
  const talentTags = useAppSelector((state) => state.talentTags.entities);

  return (
    <Box display="flex" flexWrap="wrap" gap={1}>
      {tags.map((tagId: string) => (
        <Chip
          key={tagId}
          label={talentTags[tagId]?.name || tagId} // Show tagId itself if translation not available
          style={{
            backgroundColor: "#895FDFE5",
            color: "#fff",
            borderRadius: "20px",
            padding: "5px 10px",
          }}
        />
      ))}
    </Box>
  );
};

export default TalentTags;
